// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - v7 is not defined in the uuid package
import { v7 as uuid } from 'uuid';

export class CreateUser {
  userId = `enduser-${uuid()}`;
  newUser = {
    address: {
      city: 'Cincinnati',
      country: 'US',
      state: 'OH',
      street: '101 E Central Pkwy',
      zip: '45202',
    },
    coordinates: '39.107937,-84.512708',
    email: 'jane.doe1@gmail.com',
    firstName: 'Jane',
    lastName: 'Doe',
    mobile: '',
    id: this.userId,
    type: 'apexsupplychain.citadel.helmsdeep.Endusercto',
    paidStatus: 'PAID',
    pickupStatus: 'NOT_TRANSIT',
    accountBalance: 0,
    userGroups: [],
    idActor: this.userId,
  };

  constructor(mobile: string) {
    this.newUser.mobile = mobile;
  }
}
